import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login";
import { Dashboard } from "./pages/Dashboard";
import { Delivery } from "./pages/Delivery";
import Stock from "./pages/Stock";
import Conversion from "./pages/Conversion";
import WindowStatusProcess from "./components/WindowStatusProcess";
import Reports from "./pages/Reports";
import ProtectedRoute from "./components/ProtectedRoute";
import TokenHandler from "./components/TokenHandler";
import { Ingram } from "./pages/Ingram";
import { Financial } from "./pages/Financial";
import { AccountsUsers } from "./pages/AccountsUsers";
import { Payments } from "./pages/Payments";
import { Channels } from "./pages/Channels";
import { Biblio } from "./pages/Biblio";
import { Newsletter } from "./pages/Newsletter";
import { AppLayout } from "./components/layout/AppLayout";
import { RequireModule } from "./components/layout/RequireModule";

export const Router = () => {
    const [requestStatus, setRequestStatus] = useState('close');
    const [responseText, setResponseText] = useState([]);

    return (
        <BrowserRouter>
            <TokenHandler />
            <Routes>
                <Route path="/login" element={<Login />} />

                {/* Protected Routes (app shell: sidebar + topbar) */}
                <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />

                    <Route path="/dashboard" element={<Dashboard />} />

                    <Route path="/delivery" element={<Delivery />} />

                    <Route path="/stock" element={<Stock />} />

                    <Route path="/conversions" element={<Conversion />} />

                    <Route path="/reports" element={<Reports />} />

                    <Route path="/ingram" element={<Ingram />} />

                    <Route path="/financial" element={<Financial />} />

                    <Route path="/accounts-users" element={<AccountsUsers />} />

                    <Route path="/payments" element={<Payments />} />

                    <Route path="/channels" element={<Channels />} />

                    <Route path="/biblio" element={
                        <RequireModule module="biblio" action="manage_plans" internal>
                            <Biblio />
                        </RequireModule>
                    } />
                    <Route path="/newsletter" element={
                        <RequireModule module="distribution" action="view">
                            <Newsletter />
                        </RequireModule>
                    } />
                </Route>

                {/* Fallback */}
                <Route path="*" element={<Navigate to="/dashboard" replace />} />

            </Routes>
            <WindowStatusProcess requestStatus={requestStatus} responseText={responseText} />
        </BrowserRouter>
    );
};

export default Router;
